import DashboardView from 'dashboard/DashboardView.react';
import LocaleCode from 'locale-code';
import Field from 'components/Field/Field.react';
import BoxFieldset from 'components/BoxFieldset/BoxFieldset.react';
import FlowView from 'components/FlowView/FlowView.react';
import getSiteDomain from 'lib/getSiteDomain';
import Label from 'components/Label/Label.react';
import React from 'react';
import renderFlowFooterChanges from 'lib/renderFlowFooterChanges';
import styles from 'dashboard/Settings/Settings.scss';
import stylesButton from 'components/Button/Button.scss';
import TextInput from 'components/TextInput/TextInput.react';
import Toggle from 'components/Toggle/Toggle.react';
import Toolbar from 'components/Toolbar/Toolbar.react';
import unique from 'lib/unique';
import { Promise } from 'parse';
import Notification from 'components/Notification/Notification.react';
import Autocomplete from './components/Autocomplete/Autocomplete.react';

import Countries from 'lib/countries';

const DEFAULT_EMAIL_VERIFICATION_MAIL_SUBJECT = 'Please verify your e-mail for %appname%';
const DEFAULT_EMAIL_VERIFICATION_MAIL_BODY = `Hi,

You are being asked to confirm the e-mail address %email% with %appname%

Click here to confirm it:
%link%`;
const DEFAULT_RESET_PASSWORD_MAIL_SUBJECT = 'Password Reset Request for %appname%';
const DEFAULT_RESET_PASSWORD_MAIL_BODY = `Hi,

You requested a password reset for %appname%.

Click here to reset it:
%link%`;


export default class EmailsSettings extends DashboardView {
  constructor(props) {
    super(props);
    this.section = 'App Settings';
    this.subsection = 'Emails & Hosting';

    this.state = {
      sslPublicCertUploading: false,
      sslPublicCertError: '',

      sslPrivateKeyUploading: false,
      sslPrivateKeyError: '',

      sslCertificateAuthorityUploading: false,
      sslCertificateAuthorityError: '',
      newSesEmail: '',

      hideLetsEncript: true,
    };
  }

  componentDidMount() {
    this.setState({
      default_templates_locale: this.props.initialFields ? this.props.initialFields.default_templates_locale : 'en-US',
    });
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      default_templates_locale: nextProps.initialFields ? nextProps.initialFields.default_templates_locale : 'en-US',
    });
  }

  onSelectCountry = (v) => {
    this.setState({
      country: v,
      languages: v.languages,
    });
  }

  onSelectLanguage = (v) => {
    this.setState({
      language: v,
      selectedCode: `${v.code}-${this.state.country.code}`,
    });
  }

  renderForm({
    changes, fields, setField, resetFields,
  }) {
    const {
      country, languages, language, selectedCode,
    } = this.state;


    const host_name = this.context.currentApp.settings.fields.host_name;
    const has_host_name = !!host_name;

    const letsEncrypt =
      (<div className={[styles.warningInfo, has_host_name && fields.host_name && fields.lets_encrypt ? styles.warningInfoGreen : null].join(' ')}>
        {!has_host_name || fields.host_name == '' || host_name != fields.host_name
          ? <p className={styles.onlinerTitle}>To use Free SSL with your Custom Domain please add your Host Name first.</p>
          : null
        }
        <Field
          className="oneliner"
          disabled={!has_host_name || fields.host_name == '' || host_name != fields.host_name}
          fieldPadding="0 0 0 0"
          label={<Label
            className="oneliner"
            text=" (Free SSL Certificate by Let's Encrypt)"
            iconName="icon-letsencrypt"
            sizeWidth={100}
            sizeHeight={30}
            coloredIcon
            description="Free, automated, and open Certificate Authority." />
          }
          input={<Toggle
            value={fields.lets_encrypt}
            type={Toggle.Types.YES_NO}
            onChange={setField.bind(this, 'lets_encrypt')} />
          } />
      </div>);

    const customDomainsFields =
      (<BoxFieldset el="settings__emails_custom_domains">
        <div className={styles.settingsBox}>
          <Field
            label={<Label text="Host Name" />}
            input={
              <div className={styles.inputWithButton}>
                <TextInput value={fields.host_name || ''} placeholder={'Give it a good name\u2026'} onChange={setField.bind(this, 'host_name')} />
                {fields.host_name
                  ?
                  <a
                    style={{ marginLeft: 30 }}
                    className={[stylesButton.button, stylesButton.red].join(' ')}
                    href="javascript:;"
                    onClick={() => {
                      setField('host_name', '');
                      setField('lets_encrypt', false);
                    }}>
                    Remove
                    </a>
                  : null
                }
              </div>
            } />

          <div className={styles.infoText}>
            To claim a host name, either &nbsp;<span>{(fields.host_name || 'www.example.com')}</span> or<br />
            <span>{`${this.context.currentApp.serviceName || ''}.${fields.host_name || 'www.example.com'}`}</span> must resolve a CNAME to<br />
            <span>{`pg-app-${this.context.currentApp.serviceName}.scalabl.cloud`}</span>
          </div>

          {letsEncrypt}

        </div>
      </BoxFieldset>);

    const emailSettingsFields =
      (<BoxFieldset el="settings__emails_email_settings">
        <div className={styles.settingsBox}>
          <Notification note={this.state.newSesEmail} close />
          <Field
            label={<Label
              text="Reply-to address"
              description="Emails sent from your app will come from this address." />
            }
            input={<TextInput
              value={fields.send_email_address || ''}
              onChange={setField.bind(this, 'send_email_address')} />
            } />

          <div className={[styles.warningInfo].join(' ')}>
            Once you add your email address you will receive a confirmation email from Amazon Web Services (no-reply-aws@amazon.com). Please have in mind that in case you do not confirm your email address, your app's automated email communication will stop working!
          </div>

          <div className={styles.hr} />

          <Field
            label={<Label
              text="Display name"
              description={'The name we\u2019ll use when sending emails from your app.'} />
            }
            input={<TextInput
              value={fields.sender_display_name || this.context.currentApp.name}
              onChange={setField.bind(this, 'sender_display_name')} />
            } />

          <div className={styles.hr} />

          <Field
            className="oneliner"
            label={<Label
              className="oneliner"
              text="Verify user emails"
              description="Automatically send a verification email on signup. The user's emailVerified field reflects their status." />
            }
            input={<Toggle
              value={fields.verify_emails}
              type={Toggle.Types.YES_NO}
              onChange={setField.bind(this, 'verify_emails')} />
            } />
        </div>
      </BoxFieldset>);


    const { email_templates } = fields;
    let codes = [];

    if (email_templates) {
      codes = Object.keys(email_templates).map((code, i) => {
        const c = LocaleCode.getCountryName(code);
        const lang = Countries.getLanguage(code.split('-')[0])[0].name;

        return (
          <div key={i} className={styles.emailTemplatesRow}>
            <div className={styles.c1}>
              <Toggle
                onChange={(v) => {
                  setField('default_templates_locale', code);
                  this.setState({
                    default_templates_locale: code,
                  });
                }}

                value={this.state.default_templates_locale === code} />
            </div>
            <div className={styles.c2}>
              {c}
            </div>
            <div className={styles.c3}>
              {lang}
            </div>
            <div className={styles.c4}>
              {code}
            </div>
            <div className={styles.c5}>
              <a
                className={[stylesButton.tableButton, stylesButton.blue].join(' ')}
                href="javascript:;"
                onClick={() => this.props.router.push(`${this.props.location.pathname}/templates/${code}`)}>
                Manage
              </a>
            </div>
          </div>
        );
      });
    }
    else {
      codes.push(<div key="1" className={styles.emailTemplatesRow}>
        <div className={styles.c1}>
          <Toggle
            onChange={v => null}

            value />
        </div>
        <div className={styles.c2}>
          United States
        </div>
        <div className={styles.c3}>
          English
        </div>
        <div className={styles.c4}>
          en-US
        </div>
        <div className={styles.c5}>
          <a
            className={[stylesButton.tableButton, stylesButton.blue].join(' ')}
            href="javascript:;"
            onClick={() => this.props.router.push(`${this.props.location.pathname}/templates/en-US`)}>
            Manage
          </a>
        </div>
      </div>);
    }

    const emailTemplatesFields =
      (<BoxFieldset el="settings__emails_email_templates" zIndex="5000">
        <div className={styles.settingsBox}>
          <div className={styles.emailTemplates}>
            <div className={[styles.emailTemplatesRow, styles.emailTemplatesRowTh].join(' ')}>
              <div className={styles.c1}>
                Default
              </div>
              <div className={styles.c2}>
                Country
              </div>
              <div className={styles.c3}>
                Language
              </div>
              <div className={styles.c4}>
                Locale
              </div>
              <div className={styles.c5}>
                Action
              </div>
            </div>


            {codes}

            <div className={[styles.emailTemplatesRow, styles.autocompleteHolder].join(' ')}>
              <div className={styles.c1} />
              <div className={styles.c2}>
                <Autocomplete
                  width={150}
                  defValue={country ? country.name : ''}
                  placeholder="Choose Country ..."
                  items={Countries.countries}
                  onChoose={this.onSelectCountry} />
              </div>

              <div className={styles.c3}>
                <Autocomplete
                  width={150}
                  defValue={language ? language.name : ''}
                  placeholder="Choose Language ..."
                  items={this.state.languages}
                  onChoose={this.onSelectLanguage} />
              </div>
              <div className={styles.c4}>
                {selectedCode || '...'}
              </div>
              <div className={styles.c5}>
                <a
                  className={[stylesButton.tableButton, stylesButton.green, !selectedCode ? stylesButton.disabled : ''].join(' ')}
                  href="javascript:;"
                  onClick={() => this.props.router.push(`${this.props.location.pathname}/templates/${selectedCode}`)}>
                  Add
                </a>
              </div>
            </div>

          </div>
        </div>
      </BoxFieldset>);

    const userFacingPagesFields =
      (<BoxFieldset el="settings__emails_email_customize_user_facing_pages">
        <div className={styles.settingsBox}>
          <Field
            label={<Label
              text={'Custom "choose a new password" page'}
              // getSiteDomain() is required here and not for the other templates because this template is an erb file, as opposed to the others which are html.
              description={<span>This page will be loaded when users click on a reset password link. <a href={`${getSiteDomain()}/apps/choose_password`} download="choose_password.html">Download the template</a>.</span>} />
            }
            input={<TextInput
              value={fields.choose_password_link}
              placeholder="choose_password.html"
              onChange={setField.bind(this, 'choose_password_link')} />
            } />

          <Field
            label={<Label
              text={'Custom "password changed" page'}
              description={<span>This page will be loaded when users successfully change their password. <a href="/apps/password_reset_success.html" download="password_updated.html">Download the template</a>.</span>} />
            }
            input={<TextInput
              value={fields.password_updated_link}
              placeholder="password_reset_success.html"
              onChange={setField.bind(this, 'password_updated_link')} />
            } />

          <Field
            label={<Label
              text={'Custom "email verified" page'}
              description={<span>This page will be loaded when users verify their email address. <a href="/apps/verify_email_success.html" download="email_verification.html">Download the template</a>.</span>} />
            }
            input={<TextInput
              value={fields.email_verification_link}
              placeholder="email_verification.html"
              onChange={setField.bind(this, 'email_verification_link')} />
            } />

          <Field
            label={<Label
              text='Custom "Invalid Verification page"'
            />
            }
            input={<TextInput
              value={fields.invalid_verification_link}
              placeholder="invalid_verification_link.html"
              onChange={setField.bind(this, 'invalid_verification_link')} />
            } />

          {/* <Field
            label={<Label
              text='Custom "Invalid link (404 page)"'
            />
            }
            input={<TextInput
              value={fields.invalid_link}
              placeholder="invalid_link.html"
              onChange={setField.bind(this, 'invalid_link')} />
            } /> */}
        </div>
      </BoxFieldset>);

    return (
      <div className={[styles.settings_page, 'ShowFooter'].join(' ')}>
        <Toolbar section={this.section} subsection={this.subsection} />
        <div className={styles.holder}>
          {customDomainsFields}
          {emailSettingsFields}
          {emailTemplatesFields}
          {userFacingPagesFields}
        </div>
      </div>
    );
  }

  renderContent() {
    if (!this.props.initialFields) {
      return <Toolbar section={this.section} subsection={this.subsection} />;
    }

    const initialFields = this.props.initialFields;

    return (
      <FlowView
        initialFields={initialFields}
        footerContents={({ changes }) => renderFlowFooterChanges(changes, initialFields, userFieldOptions)}
        onSubmit={({ changes, fields, setField }) => {
          if (changes.default_templates_locale !== initialFields.default_templates_locale) {
            changes = {
              ...changes,
              ...initialFields.email_templates[changes.default_templates_locale],
            };
          }

          return this.props.saveChanges(changes).then(({ successes, failures }) => {
            for (const k in successes) {
              setField(k, successes[k]);
            }

            if (Object.keys(failures).length > 0) {
              return { error: Object.values(failures).join(' ') };
            }

            if (successes.send_email_address) {
              this.setState({ newSesEmail: { type: 'info', message: `A verification e-mail was sent to ${successes.send_email_address}` } });
            }
          })
            .catch(({ error, failures = {} }) => {
              return { error: unique(Object.values(failures).concat(error)).join(' ') };
            });
        }}
        validate={() => ''}
        renderForm={this.renderForm.bind(this)} />
    );
  }
}

let userFieldOptions = {
  external_frame_link: {
    friendlyName: 'parse frame URL',
    showTo: true,
  },
  invalid_link_link: {
    friendlyName: 'custom 404 page',
  },
  choose_password_link: {
    friendlyName: 'custom "choose a new password" page',
  },
  email_verification_link: {
    friendlyName: 'custom "email verified" page',
  },
  password_updated_link: {
    friendlyName: 'custom "password changed" page',
  },

  subdomain_name: {
    friendlyName: 'subdomain name',
    showFrom: true,
    showTo: true,
  },

  send_email_address: {
    friendlyName: 'reply-to address',
    showTo: true,
  },
  sender_display_name: {
    friendlyName: 'display name',
    showTo: true,
    showFrom: true,
  },
  verify_emails: {
    friendlyName: 'user email verification',
    type: 'boolean',
  },

  host_name: {
    friendlyName: 'host name',
    showTo: true,
  },

  default_templates_locale: {
    friendlyName: 'default Email Templates',
  },

  email_verification_mail_subject: {
    friendlyName: 'verification email subject',
  },
  email_verification_mail_body: {
    friendlyName: 'verification email body',
  },
  reset_password_mail_subject: {
    friendlyName: 'password reset subject',
  },
  reset_password_mail_body: {
    friendlyName: 'password reset email body',
  },
};
